$(document).ready(function () {
      $('#modal-1').addClass("md-show"); //you can list several class names
});

$(".popup-box").click(function() {
    $("#modal-1").removeClass("md-show");
});

$('.mfp-close').on('click', function() {
    $('#modal-1').toggleClass("md-show"); //you can list several class names
});
